import { render, staticRenderFns } from "./recaptcha.vue?vue&type=template&id=7be66a12&"
import script from "./recaptcha.vue?vue&type=script&lang=js&"
export * from "./recaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7be66a12')) {
      api.createRecord('7be66a12', component.options)
    } else {
      api.reload('7be66a12', component.options)
    }
    module.hot.accept("./recaptcha.vue?vue&type=template&id=7be66a12&", function () {
      api.rerender('7be66a12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/recaptcha.vue"
export default component.exports